import React from "react";
import { Switch, withRouter } from "react-router-dom";

const PerformRoutes = ({ match }) => (
  <div>
    <Switch>
      {/* <Route path={`${match.path}/okr`} component={Okr} /> */}
      {/* <Route path={`${match.path}/360degreereview`} component={Review} /> */}
      {/* <Route
        exact
        path={`${match.path}/app/perform/360degreereview`}
        component={ReviewManger}
      /> */}
      {/* <Route path="**" component={PageNotFound} /> */}
    </Switch>
  </div>
);

export default withRouter(PerformRoutes);
